import { getTheme } from '../_next/core/utils';
import { Theme } from '../types';

export const getThemeColorSchema = (theme: Theme | string) => {
  if (!theme) theme = 'Default';
  const _theme = getTheme(theme as Theme);
  const colors = _theme.colors;
  return colors;
};
